// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___C8b1M","root_center":"style-module__root_center___wkhzK","root__title":"style-module__root__title___vX4Qy","root__fee":"style-module__root__fee___TLgxF"};
    if(module.hot) {
      // 1697460472168
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  